import React, { memo, useState } from 'react';
import {
  Stack,
  Card,
  Typography,
  Divider,
  Icon,
  Button,
  Dialog,
  DialogTitle,
  DialogContent
} from 'investira.react.components';

const SugestaoCard = memo(props => {
  const { disabled, questao } = props;
  const [open, setOpen] = useState();

  function handleDialogOpen(e, pValue) {
    e.stopPropagation();
    e.preventDefault();
    setOpen(pValue);
  }

  if (disabled) {
    return (
      <Stack>
        <Icon iconName="ia" color={'secondary'} size={21} />
      </Stack>
    );
  }

  return (
    <>
      <Stack
        onClick={e => handleDialogOpen(e, true)}
        sx={{
          pointerEvents: 'auto',
          cursor: 'pointer'
        }}>
        <Icon iconName="ia" color={'primary'} size={21} />
      </Stack>
      <Dialog open={open} onClose={e => handleDialogOpen(e, false)}>
        <Card>
          <Stack m={2} gap={2}>
            <Stack alignItens="center" gap={1}>
              <Stack direction="row" alignItens="center" gap={1} justifyContent="space-between">
                <Stack direction="row" flexGrow={1}>
                  <Icon iconName="ia" color={'primary'} size={21} />
                </Stack>
                <Stack
                  onClick={e => handleDialogOpen(e, false)}
                  sx={{
                    pointerEvents: 'auto',
                    cursor: 'pointer'
                  }}>
                  <Icon iconName="cancel" color={'primary'} size={18} />
                </Stack>
              </Stack>
              <Typography color="textPrimary" variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
                Sugestão de justificativa
              </Typography>
            </Stack>
            <Stack>
              <Typography color="textPrimary" variant="caption">
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam aliquet, risus nec
                facilisis tempor, neque mi tincidunt enim, non luctus dolor enim id sem.
                Pellentesque consequat, nisi ac dignissim interdum, sem risus faucibus elit, et
                euismod turpis purus sed elit. Quisque rutrum, diam vitae feugiat."
              </Typography>
            </Stack>
            <Stack>
              <Button size="small" variant="contained">
                Usar sugestão
              </Button>
            </Stack>
          </Stack>
        </Card>
      </Dialog>
    </>
  );
});

export default SugestaoCard;
